module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        showColorBar: true,
        tabConfigNavKey: 'drivers',
        parentEntityPreparationGranted: false,
        showEditByMySelf: true,
    },
}